import { useState } from 'react';

const ImageOnLoadRPC = ({
	children,
	placeholder = null,
	ignoreError = false
}) => {
	const [isError, setIsError] = useState(false);
	const [isLoaded, setIsLoaded] = useState(false);
	const handleSetLoadError = () => setIsError(true);
	const handleSetLoaded = () => setIsLoaded(true);

	if (isError && !ignoreError) return placeholder;

	return children({
		setError: handleSetLoadError,
		isLoaded,
		setLoaded: handleSetLoaded,
		isError
	});
};

export default ImageOnLoadRPC;
